(function() {
  'use strict';

  function initBlk2Stars() {
    // metafield judgeme.badge ベースの Liquid 出力で完結。
    // hidden 属性は Liquid 側で metafield 空時のみ付与されるため、
    // JS 側での件数判定・表示制御は不要。
    // （将来 JS 動的描画方式へ戻す場合に備えて関数自体は残置）
  }

  function getStickyHeaderOffset() {
    const candidates = [
      'sticky-header',
      '.shopify-section-header-sticky',
      '.shopify-section-header',
      '.header-wrapper',
      '.section-header'
    ];
    for (const sel of candidates) {
      const el = document.querySelector(sel);
      if (el) {
        const h = el.getBoundingClientRect().height;
        if (h > 0) return h + 8;
      }
    }
    return 80;
  }

  function initAnchorScroll() {
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-jc-scroll-to-reviews]');
      if (!link) return;
      e.preventDefault();
      const target = document.getElementById('jc-blk7-reviews');
      if (!target) return;
      const headerOffset = getStickyHeaderOffset();
      const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  }

  // Judge.me がレビューを描画したかを判定する。
  // - レガシー: .jdgm-rev-widg[data-number-of-reviews]
  // - V3 アプリブロック: マークアップが異なる可能性があるため、
  //   [data-number-of-reviews] を持つ任意の要素、または .jdgm-rev（レビューカード）の存在でも判定する
  function widgetHasReviews(container) {
    const counted = container.querySelector('[data-number-of-reviews]');
    if (counted) {
      const n = parseInt(counted.dataset.numberOfReviews || '0', 10);
      if (n > 0) return true;
    }
    return container.querySelectorAll('.jdgm-rev').length > 0;
  }

  // BLK2 のプレビューバッジ（metafield judgeme.badge）が示すレビュー件数。
  // ウィジェットが描画されなくても、バッジが 1 件以上なら「まだレビューがありません」とは表示しない
  // （2026-10-30: judgeme.widget が空のためウィジェットが出ない状態で、誤った 0 件表示を防ぐ）
  function badgeReviewCount() {
    const badge = document.querySelector('.jdgm-prev-badge[data-number-of-reviews]');
    if (!badge) return 0;
    return parseInt(badge.dataset.numberOfReviews || '0', 10) || 0;
  }

  function initEmptyStateDetection() {
    const widgetContainer =
      document.querySelector('[data-jc-blk7-widget]') ||
      document.getElementById('judgeme_product_reviews');
    const emptyState = document.querySelector('[data-jc-blk7-empty]');
    if (!widgetContainer || !emptyState) return;

    const SETTLE_MS = 6000;   // この時間までに描画されなければ 0 件扱い
    const GIVE_UP_MS = 20000; // 遅延描画を拾う監視の上限

    let rendered = false;
    const checkRendered = () => {
      if (widgetHasReviews(widgetContainer)) {
        rendered = true;
        emptyState.hidden = true;
        return true;
      }
      return false;
    };

    if (checkRendered()) return;

    const observer = new MutationObserver(() => {
      if (checkRendered()) observer.disconnect();
    });
    observer.observe(widgetContainer, { childList: true, subtree: true, attributes: true });

    setTimeout(() => {
      if (!rendered && !checkRendered()) {
        emptyState.hidden = badgeReviewCount() > 0;
      }
    }, SETTLE_MS);

    setTimeout(() => observer.disconnect(), GIVE_UP_MS);
  }

  function initPaginationScrollFix() {
    document.addEventListener('click', (e) => {
      const link = e.target.closest(
        '.jdgm-paginate__page, .jdgm-paginate__next-page, .jdgm-paginate__prev-page'
      );
      if (!link) return;

      setTimeout(() => {
        const widget = document.querySelector('.jdgm-rev-widg') || document.querySelector('[data-jc-blk7-widget]');
        if (!widget) return;
        const headerOffset = getStickyHeaderOffset();
        const top = widget.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({ top, behavior: 'smooth' });
      }, 250);
    });
  }

  function init() {
    initBlk2Stars();
    initAnchorScroll();
    initEmptyStateDetection();
    initPaginationScrollFix();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
